export default {
  en: {
    'pages.messages.title': 'Messages',
    'pages.messages.all-messages': 'See all messages',
    'pages.messages.filing-title': 'Filing Messages',
    'pages.messages.general-title': 'General Messages',
    'pages.messages.general': 'General',
    'pages.messages.new': 'New Message',
    'pages.messages.inbox': 'Inbox',
    'pages.messages.archive': 'Archive',
    'pages.messages.to': 'To: {userList}',
    'pages.messages.from': 'From: {name}',
    'pages.messages.reference-to': 'Reference to: ',
    'pages.messages.subject': 'Subject: ',
    'pages.messages.send': 'Send',
    'pages.messages.send.success': 'Message sent successfully',
    'pages.messages.participants': 'Participants',
    'pages.messages.reply': 'Reply',
    'pages.messages.filing-link': 'View filing',
    'pages.messages.search': 'Search',
    'pages.messages.filter.status': 'Status',
    'pages.messages.filter.status.mark-as': 'Mark as {status}',
    'pages.messages.filter.status.archive': 'Archive',
    'pages.messages.filter.status.unarchive': 'Unarchive',
    'pages.messages.filter.date-from': 'From',
    'pages.messages.filter.date-to': 'To',
    'pages.messages.no-results.no-messages.title': "You don't have any messages yet",
    'pages.messages.no-results.no--filtered-messages.title': 'No matching messages found',
    'pages.messages.filter.date-to.error.min-date': 'Date cannot be before from date',
  },
};
